















import { openList } from '@/main/router/routerPath';
import { ListLoadBehavior } from '@/main/utils/listLoadBehavior';

import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

import { NAME } from '../constants';

export default BaseInput.extend({
	name: 'SkladMistoPneuSelectInput',
	components: { DmsWrapper },
	props: {
		labelKey: { type: String, required: true },
		buttonLabelKey: { type: String, default: 'SKLADMISTA' },
		value: { type: Number },
		span: { type: Number, default: 24 },
		noLabelAlign: { type: Boolean, default: false },
	},
	computed: {
		input: {
			get(this: { value: number }) {
				return this.value;
			},
			set(val) {
				this.$emit('update:value', Number(val));
			},
		},
		localizedButtonLabel() {
			return this.LocalizeMultiKey(this.buttonLabelKey);
		},
	},
	methods: {
		skladMistaClicked() {
			openList(NAME, {
				filter: { SkladpneuOzn: this.input },
				listLoadBehavior: ListLoadBehavior.HIDE_FILTER,
			});
		},
	},
});
